import { logger } from '@/lib/logger';

const COMMON_PAYLOAD = {
  flow: 'RMG',
  state_name: 'create_ac_add_bank',
};

const logFPTIForRealMoneyGamingPage = {
  onContinueButtonClick: (): void => {
    logger.fpti('primary_continue_button_was_clicked', {
      ...COMMON_PAYLOAD,
      button_label: 'buttons.guest.base',
      transition_name: 'process_create_ac_add_bank',
    });
  },
  onRMGLandingPageLoad: (): void => {
    logger.fpti('real_money_gaming_page_loaded', {
      ...COMMON_PAYLOAD,
      transition_name: 'prepare_create_ac_add_bank',
    });
  },
};

export { logFPTIForRealMoneyGamingPage };
